import { ThemeProvider } from "@mui/material/styles";
import { muiTheme } from "@polifonia/theme";
import { memo } from "react";

export const MuiThemeProvider = memo(function MuiThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
});
